export const REF_NAME = 'BANK';
export const REF_PATH = 'bank';
export const NAME = 'Bank';
